import { useMemo } from "react";
import { useMatches } from "react-router-dom";
import { moduleRegistry } from "./index";
import { isModuleRouteHandle, type ModuleInstance } from "./types";

/**
 * Aktif modül instance'ı — data router `handle.moduleId` üzerinden.
 * `isChatPage` / `isCommercePage` gibi pathname string kontrollerinin yerini alır.
 *
 * Yalnızca data router (`createBrowserRouter`) içinde çalışır.
 * Shared route'larda (cart, settings…) `undefined` döner.
 */
export const useActiveModule = (): ModuleInstance | undefined => {
  const matches = useMatches();

  return useMemo(() => {
    // En derin eşleşmeden geriye: iç route handle'ı dış route'u ezebilsin.
    for (let i = matches.length - 1; i >= 0; i -= 1) {
      const handle = matches[i].handle;
      if (isModuleRouteHandle(handle)) {
        return moduleRegistry.getModuleById(handle.moduleId);
      }
    }
    return undefined;
  }, [matches]);
};
